import { PayloadAction } from '../../../../store.model';
import { ActionType } from '../task-list-dialog.action';
import { defaultState, TaskListDialogState } from '../task-list-dialog.state';

import { Reset } from './reset.action';

export function resetReducer(
    state: TaskListDialogState,
    action: PayloadAction<ActionType.TC__TL__RESET, Reset>,
): TaskListDialogState {
    return defaultState();
}
